var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20393 0.208496C2.94595 0.208496 2.71692 0.360509 2.63534 0.585877L0.2441 7.19181C0.220126 7.25147 0.207031 7.31599 0.207031 7.38332V7.38337C0.207031 7.38339 0.207031 7.38341 0.207031 7.38343V12.9024C0.207031 13.2072 0.475368 13.4543 0.806378 13.4543H15.1907C15.5217 13.4543 15.79 13.2072 15.79 12.9024V7.40155C15.7922 7.34185 15.7838 7.28089 15.7636 7.22078C15.762 7.21585 15.7602 7.21094 15.7585 7.20606L13.3621 0.585877C13.2805 0.360509 13.0514 0.208496 12.7935 0.208496H3.20393ZM14.3593 6.83141L12.3615 1.31232H3.63591L1.63809 6.83141H5.60115C5.93216 6.83141 6.20049 7.07851 6.20049 7.38332C6.20049 8.29271 7.01098 9.03905 7.99853 9.03905C8.98608 9.03905 9.79657 8.29271 9.79657 7.38332C9.79657 7.07851 10.0649 6.83141 10.3959 6.83141H14.3593ZM1.40572 12.3505V7.93523H5.06229C5.34152 9.19168 6.55409 10.1429 7.99853 10.1429C9.44298 10.1429 10.6555 9.19168 10.9348 7.93523H14.5913V12.3505H1.40572Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/ArchiveIcon.49773a92.svg";
export { ForwardRef as ReactComponent };